/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TriviaAnswerBody
 */
export interface TriviaAnswerBody {
    /**
     * The ID of the question being answered
     * @type {string}
     * @memberof TriviaAnswerBody
     */
    questionId: string;
    /**
     * Zero-based index of the selected option
     * @type {number}
     * @memberof TriviaAnswerBody
     */
    optionIndex: number;
}

/**
 * Check if a given object implements the TriviaAnswerBody interface.
 */
export function instanceOfTriviaAnswerBody(value: object): value is TriviaAnswerBody {
    if (!('questionId' in value) || value['questionId'] === undefined) return false;
    if (!('optionIndex' in value) || value['optionIndex'] === undefined) return false;
    return true;
}

export function TriviaAnswerBodyFromJSON(json: any): TriviaAnswerBody {
    return TriviaAnswerBodyFromJSONTyped(json, false);
}

export function TriviaAnswerBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): TriviaAnswerBody {
    if (json == null) {
        return json;
    }
    return {
        
        'questionId': json['questionId'],
        'optionIndex': json['optionIndex'],
    };
}

export function TriviaAnswerBodyToJSON(json: any): TriviaAnswerBody {
    return TriviaAnswerBodyToJSONTyped(json, false);
}

export function TriviaAnswerBodyToJSONTyped(value?: TriviaAnswerBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'questionId': value['questionId'],
        'optionIndex': value['optionIndex'],
    };
}

